// utils/formatting.js

export function dollarFormat(value) {
    if (typeof value === "number") {
        return `$${value.toFixed(2)}`;
    }

    if (typeof value === "string") {
        const trimmed = value.trim();
        if (trimmed.startsWith("$")) {
            return trimmed;
        }

        const num = parseFloat(trimmed);
        if (!isNaN(num)) {
            return `$${num.toFixed(2)}`;
        }

        return value; // Not a number-like string, return as-is
    }

    return value; // Fallback for other types
}

export function toFloat(value) {
    if (typeof value === "string") {
        // Remove dollar sign, commas, and trim whitespace
        value = value.replace(/[$,]/g, '').trim();
    }
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
}


export function roundFormat(value) {
    if (typeof value === "number") {
        return parseFloat(value.toFixed(2));
    }

    return value;
}

// Convert epochMillis to ISO 8601 style string that is implicitly in the user's local timezone (for the purpose of showing in a datetime-local input (shows the user the time in their timezone))
export function epochToIso8601(epochMillis) {
    const date = new Date(epochMillis);
    const formatter = new Intl.DateTimeFormat("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
    const [
        {value: year},
        ,
        {value: month},
        ,
        {value: day},
        ,
        {value: hour},
        ,
        {value: minute},
    ] = formatter.formatToParts(date);
    return `${year}-${month}-${day}T${hour}:${minute}`;
};

//Input is in the datetime-local timezone (the user's local timezone)
// e.g., ISO8601 format: "2025-02-26T14:30" OR UTC String format: "Sun, 02 Mar 2025 07:05:27 GMT"
export function toEpoch(input) {
    if (Number.isInteger(input)) {
        return input
    }

    return new Date(input).getTime()
}

export function datetimeLocalToEpoch(datetimeLocalInputEventValue) {
    //datetimeLocalInputEventValue: In the datetime-local timezone (the user's local timezone) // e.g., "2025-02-26T14:30" OR "Sun, 02 Mar 2025 07:05:27 GMT"
    const iso = new Date(datetimeLocalInputEventValue).toISOString();
    return toEpoch(iso)
};